import { createFileRoute } from '@tanstack/react-router'
import { StaffKesehatan } from '../../../../components/StaffKesehatan'

export const Route = createFileRoute('/platform/desa/$desaId/kesehatan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffKesehatan desaId={desaId} />
  },
})
